export default __webpack_public_path__ + "static/media/Pollution-de l’air.64448a5e.svg";